module.exports = __webpack_public_path__ + "static/media/grin-squint-tears.b599df61.svg";